import { saleForms } from '@/shared/config/expiration-forms';

export const productsStatisticTypes = [
  { value: 'amount', label: 'Статистика продажів ₴', description: 'Цього місяця ви здійснили продажів на' },
  { value: 'count', label: 'Статистика продажів ШТ', description: 'Цього місяця ви здійснили', expiration_forms: saleForms.forms, },
  { value: 'earnings', label: 'Комісійні винагороди ₴', description: 'Цього місяця ви заробили' },
];
